import { render, staticRenderFns } from "./character.vue?vue&type=template&id=2316dac6&scoped=true"
import script from "./character.vue?vue&type=script&lang=js"
export * from "./character.vue?vue&type=script&lang=js"
import style0 from "./character.vue?vue&type=style&index=0&id=2316dac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316dac6",
  null
  
)

export default component.exports